import { Box } from "@mui/material";
import * as React from "react";

interface IProps {
    children?: React.ReactNode;
    variant?: MprcColorVariant;
}

type Props = IProps;

export const MprcTextMuted: React.FC<Props> = (props) => {
    const { children, variant = "main", ...rest } = props;

    return (
        <Box
            {...rest}
            component="span"
            sx={
                (theme) => ({
                    color: theme.palette.muted[variant]
                })
            }
        >
            {children}
        </Box>
    );
};
